var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { Form, FieldGroup, FieldLabel, FieldError, ButtonGroup, } from './styles';
import Button from '../Common/AdminButton/Button';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import TextInput from 'src/Components/Common/TextInput';
import { useAdminUserOptions } from 'src/Utils/hooks/useAdminUserOptions';
import CalendarComponent from '../Common/Calendar';
import { ticketsService } from 'src/Utils/ticketsService';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
import { useQuery } from 'react-query';
import { ROUTES } from 'src/Utils';
var validationSchema = yup
    .object({
    ticket_id: yup
        .number()
        .typeError('El número de ticket es requerido')
        .required('El número de ticket es requerido'),
    date: yup.date().required('La fecha es requerida'),
    recipient_id: yup.number().required('El destinatario es requerido'),
})
    .required();
function TicketReminderForm(_a) {
    var _b, _c;
    var propsTicketId = _a.ticketId, ticketReminder = _a.ticketReminder, onSubmit = _a.onSubmit, _d = _a.submitLoading, submitLoading = _d === void 0 ? false : _d;
    var history = useHistory();
    var _e = useQuery('ticket-reminder-tickets', ticketsService.getTicketReminderTicketOptions), _f = _e.data, ticketOptions = _f === void 0 ? [] : _f, isLoadingTickets = _e.isLoading;
    var ticketOptionsWithCurrent = useMemo(function () {
        if (ticketReminder) {
            var hasCurrentTicket_1 = ticketOptions.some(function (option) { return option.value === ticketReminder.ticket_id; });
            if (hasCurrentTicket_1) {
                return ticketOptions;
            }
            return __spreadArrays([
                {
                    value: ticketReminder.ticket_id,
                    label: ticketReminder.ticket_title,
                }
            ], ticketOptions);
        }
        if (!propsTicketId) {
            return ticketOptions;
        }
        var hasCurrentTicket = ticketOptions.some(function (option) { return option.value === propsTicketId; });
        if (hasCurrentTicket) {
            return ticketOptions;
        }
        return __spreadArrays([
            {
                value: propsTicketId,
                label: "Ticket #" + propsTicketId,
            }
        ], ticketOptions);
    }, [ticketOptions, ticketReminder, propsTicketId]);
    var _g = useForm({
        defaultValues: ticketReminder
            ? {
                ticket_id: ticketReminder.ticket_id,
                date: dayjs(ticketReminder.date).toDate(),
                recipient_id: ticketReminder.recipient.id,
            }
            : {
                ticket_id: propsTicketId,
                date: dayjs().add(2, 'days').toDate(),
                recipient_id: undefined,
            },
        resolver: yupResolver(validationSchema),
    }), handleSubmit = _g.handleSubmit, _h = _g.formState, errors = _h.errors, isSubmitting = _h.isSubmitting, control = _g.control;
    var _j = useAdminUserOptions(), isLoadingAdminOptions = _j.isLoading, adminUserOptions = _j.adminUserOptions;
    var handleCancel = function () {
        history.push(ROUTES.recordatorios_de_tickets);
    };
    var isFormDisabled = isLoadingAdminOptions ||
        isLoadingTickets ||
        errors.ticket_id !== undefined ||
        isSubmitting ||
        submitLoading;
    return (React.createElement(Form, { onSubmit: handleSubmit(onSubmit) },
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Ticket"),
            React.createElement(Controller, { name: "ticket_id", control: control, render: function (field) { return (React.createElement(SearchableSelect, { value: field.value, onChange: field.onChange, placeholder: "Seleccione un ticket...", options: ticketOptionsWithCurrent })); } }),
            React.createElement(FieldError, null, (_b = errors.ticket_id) === null || _b === void 0 ? void 0 : _b.message)),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Destinatario"),
            React.createElement(Controller, { name: "recipient_id", control: control, render: function (field) { return (React.createElement(SearchableSelect, { value: field.value, onChange: field.onChange, placeholder: "Recordatorio para...", options: adminUserOptions })); } }),
            React.createElement(FieldError, null, (_c = errors.recipient_id) === null || _c === void 0 ? void 0 : _c.message)),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Fecha"),
            React.createElement(Controller, { name: "date", control: control, render: function (field) { return (React.createElement(CalendarComponent, { selected: field.value, onChange: field.onChange, customInput: React.createElement(TextInput, { style: { width: '100%' } }), minDate: dayjs().add(1, 'day').toDate() })); } }),
            React.createElement(FieldError, null, errors.date && 'La fecha debe ser futura')),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { className: "white", type: "button", onClick: handleCancel }, "Cancelar"),
            React.createElement(Button, { disabled: isFormDisabled, type: "submit" }, "Guardar"))));
}
export default TicketReminderForm;
